import { gql } from "@apollo/client";

export const reserveMailinTicketRequest = gql`
  mutation ReserveMailinTicketRequest($sweepstakesId: SweepstakesSlug!) {
    reserveMailinTicketRequest(sweepstakesId: $sweepstakesId) {
      mailinTicketRequestReservation {
        id
      }
      error {
        code
        message
      }
    }
  }
`;

export const createMailinTicketRequestMutation = gql`
  mutation CreateMailinTicketRequest($sweepstakesId: SweepstakesSlug!, $attributes: MailinTicketRequestInput!, $captcha: String!, $reservationId: String!) {
    createMailinTicketRequest(sweepstakesId: $sweepstakesId, attributes: $attributes, captcha: $captcha, reservationId: $reservationId) {
      mailinTicketRequest {
        id
        downloadUrl
      }
      error {
        code
        message
      }
    }
  }
`;
